module.exports = __webpack_public_path__ + "img/surveyEmoji4.8c8255a9.svg";